import React from 'react';
import { useTranslate } from '@hooks';
import { PaginationListSimple } from '@dotone/react-ui-core';

const Pagination = ({ pagination, onChange }) => {
  const { t } = useTranslate('common', 'pagination');

  const handleClick = (action) => {
    const page = pagination.page + (action === t('next') ? 1 : -1);
    onChange({ page });
  };

  return <PaginationListSimple {...pagination} onPageChange={handleClick} />;
};

export default Pagination;
